import WorkCard from "@/components/base/WorkCard";
import type { Work } from "@/types/work";

interface RelatedSectionProps {
  list: Work[];
}

export default function RelatedSection({ list }: RelatedSectionProps) {
  if (list.length === 0) return null;
  return (
    <section>
      <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
        <span className="h-5 w-1.5 rounded-full bg-accent-500" />
        相关推荐
      </h2>
      <p className="mt-2 text-xs text-foreground-500 md:text-sm">
        基于类型与主演综合匹配，为你看更多相似作品
      </p>
      <div className="mt-5 grid grid-cols-2 gap-4 md:grid-cols-4">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}